import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useContractSearchDispatch, useContractSearchState } from './contract-search-context';
import { useBaseData } from '../../../../application/context/base-data-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';
import { ContractSortField } from '../../../../model/scp/contract/contract-sort-field';
import { SortDirection } from '../../../../model/scp/base/sort-direction';

const DEFAULT_SORT_BY = ContractSortField.UpdatedDate;
const DEFAULT_SORT_DIRECTION = SortDirection.Descending;

export const useContractSearchController = () => {
    const navigate = useNavigate();
    const { showLoading } = useBaseLayout();
    const dispatch = useContractSearchDispatch();
    const state = useContractSearchState();
    const baseData = useBaseData();

    useEffect(() => {
        showLoading({ open: !baseData.loaded });
        if (baseData.loaded) {
            dispatch({ type: ACTION_TYPES.setTypeContract, payload: baseData.typeContract });
            dispatch({ type: ACTION_TYPES.setCategoryProcess, payload: baseData.categoryProcess });
        }
    }, [baseData.loaded]);

    function handleOnChange(e: any) {
        let term = state.parameters.term;
        let categoryProcessId = state.parameters.categoryProcessId;
        let contractTypeId = state.parameters.contractTypeId;
        let clientId = state.parameters.clientId;
        let year = state.parameters.year;
        let sortBy = state.parameters.sortBy;
        let sortDirection = state.parameters.sortDirection;

        if (e.target.name === "input-term") {
            term = e.target.value;
        }
        if (e.target.name === "select-category-process") {
            categoryProcessId = e.target.value;
        }
        if (e.target.name === "select-contract-type") {
            contractTypeId = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }
        if (e.target.name === "input-year") {
            const parsed = parseInt(e.target.value, 10);
            year = isNaN(parsed) ? undefined : parsed;
        }
        if (e.target.name === "select-sort") {
            if (e.target.value) {
                const [sortByValue, sortDirectionValue] = e.target.value.split('_');
                sortBy = Number(sortByValue);
                sortDirection = Number(sortDirectionValue);
            } else {
                sortBy = DEFAULT_SORT_BY;
                sortDirection = DEFAULT_SORT_DIRECTION;
            }
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                term,
                clientId,
                categoryProcessId,
                contractTypeId,
                year,
                sortBy,
                sortDirection
            }
        });
    }

    function handleSearch() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                ...state.parameters,
                page: 0
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: {
                page: 0,
                pageSize: 100,
                term: undefined,
                clientId: undefined,
                categoryProcessId: undefined,
                contractTypeId: undefined,
                year: undefined,
                sortBy: DEFAULT_SORT_BY,
                sortDirection: DEFAULT_SORT_DIRECTION
            }
        });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() {
        navigate('/contratos/publicar');
    }

    return {
        handleOnChange,
        handleSearch,
        handleClearFilters,
        navigateToCreate
    };
}
